module.exports = "/images/novaoito.png?9ef9544b79116c29a6be8557bb0e83f9";